var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',{attrs:{"color":_vm.color,"small":_vm.small,"x-small":_vm.xSmall}},[_vm._v(_vm._s(_vm.icon))])
}
var staticRenderFns = []

export { render, staticRenderFns }